import usePaperExport from "@/hooks/usePaperExport";
import useTranslation from "@/hooks/useTranslation";
import { AuditOutlined } from "@ant-design/icons";
import fileDownload from "js-file-download";
import React, { useEffect } from "react";
import styles from "../styles.module.less";

const { itemContainer, itemIcon, itemText } = styles;

interface IProps {
  doi: string;
  pmid: string;
}

const Export: React.FC<IProps> = ({ doi, pmid }) => {
  const { t } = useTranslation("explore");
  const { loadExport, data } = usePaperExport(doi);

  useEffect(() => {
    if (data?.getRIS) {
      fileDownload(data?.getRIS, `${pmid}.ris`);
    }
  }, [data]);

  return (
    <div className={itemContainer} key={doi} onClick={() => loadExport()}>
      <div className={itemIcon}>
        <AuditOutlined />
      </div>
      <div className={itemText}>{t("tab.helper.export")}</div>
    </div>
  );
};

export default Export;
